import { api } from '_/services/api';

import { mapGetters } from 'vuex';

import { config } from '_/config/config';

export default {
    /**
     * Set the component data
     *
     * @return  {object}
     */
    data: function() {
        return {
            scannedProductsInReceipt: [],
        };
    },

    /**
     * Set the computed properties
     *
     * @type {object}
     */
    computed: {
        ...mapGetters({
            admin: 'admin/admin',
        }),

        /**
         * Hides the Extra Products in receipts sidebar section
         *
         * @return  {Boolean}
         */
        isProductsInReceiptsVisible() {
            return (this.$route.params.moduleTableName === 'scanned_products' && _.has(this.$route.params, 'moduleEntryId'));
        },

        /**
         * Returns the current scanned product id
         *
         * @return  {integer}
         */
        receiptId () {
            if (_.has(this.admin.editedEntry.receipt_number, 'id')) {
                return this.admin.editedEntry.receipt_number.id;
            }

            if(_.has(this.admin.editedEntry, 'receipt_number')) {
                return this.admin.editedEntry.receipt_number;
            }

            return null;
        }
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        fetchProductsInReceipt () {
            if(!this.isProductsInReceiptsVisible) {
                return;
            }

            const payload = {
                'filter': {
                    'receipt_number': {
                        'equal': this.receiptId
                    },
                }
            };

            api.post(`${config.ENV.apiBasePath}/filter/scanned_products`, payload)
                .then(response => {
                    this.scannedProductsInReceipt = response.body.body.entries;
                })
                .catch((response) => {
                    pError('Failed to load products in receipt.', response);
                });
            }
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted () {
        this.$nextTick(() => {
            this.fetchProductsInReceipt();
        });
    },

    /**
     * Define watched properties
     *
     * @type  {Object}
     */
    watch: {
        /**
         * Watching the route change
         *
         * @return  {void}
         */
        'admin.editedEntry.id' (newEntry, oldEntry) {
            if (newEntry == oldEntry) {
                return;
            }

            this.fetchProductsInReceipt();
        },

        'admin.editedEntry.receipt_number' (newEntry, oldEntry) {
            if (newEntry == oldEntry) {
                return;
            }

            this.fetchProductsInReceipt();
        },
    },
};
